import { render } from "./RegistrationComplete.vue?vue&type=template&id=19668d30&scoped=true"
import script from "./RegistrationComplete.vue?vue&type=script&lang=js"
export * from "./RegistrationComplete.vue?vue&type=script&lang=js"

import "./RegistrationComplete.vue?vue&type=style&index=0&id=19668d30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19668d30"]])

export default __exports__